/**
 * EmptyState — hero-style callout for "no data yet". Used by Vault,
 * later by Marketplace and Attestation viewer.
 */

import type { ReactNode } from 'react';

export function EmptyState({
  icon,
  title,
  body,
  primaryAction,
  secondaryAction,
  tertiaryAction,
}: {
  icon?: ReactNode;
  title: ReactNode;
  body: ReactNode;
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
  tertiaryAction?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-surface px-8 py-14 text-center">
      {icon ? (
        <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-spark-soft text-spark">
          {icon}
        </div>
      ) : null}
      <h2 className="text-xl font-semibold text-ink">{title}</h2>
      <p className="mt-2 max-w-md text-sm text-ink-muted">{body}</p>
      {primaryAction || secondaryAction || tertiaryAction ? (
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {primaryAction}
          {secondaryAction}
          {tertiaryAction}
        </div>
      ) : null}
    </div>
  );
}
